import React, { useCallback, useState } from "react";
import { TextAreaAtom } from "../../../../../components/atoms/atom";

const PositionCommentInput = React.memo(
	({ invoicePositionId, initialValue, isReadonly, onSave, placeholder }) => {
		const [value, setValue] = useState(initialValue || "");

		React.useEffect(() => {
			setValue(initialValue || "");
		}, [initialValue]);

		const handleBlur = useCallback(() => {
			if (value !== initialValue) {
				onSave(invoicePositionId, value);
			}
		}, [value, initialValue, invoicePositionId, onSave]);

		if (isReadonly) {
			return value ? (
				<span className="comment-readonly">{value}</span>
			) : null;
		}

		return (
			<TextAreaAtom
				className="comment-input"
				value={value}
				rows={2}
				onChange={(e) => setValue(e.target.value)}
				onBlur={handleBlur}
				placeholder={placeholder}
			/>
		);
	},
);

export default PositionCommentInput;
